module.exports = {
    "collapse": `Reduzieren`,
    "expand": `Erweitern`
};


//# sourceMappingURL=de-DE.main.js.map
